import { AlertTriangle } from 'lucide-react';
import { useCompany } from '@/contexts/CompanyContext';

export function TestModeBanner() {
    const { selectedCompany } = useCompany();
    const testMode = selectedCompany?.settings?.testMode;
    if (!testMode?.enabled) return null;

    const overrideEmail = testMode.overrideEmail?.trim();

    return (
        <div className="bg-amber-100 dark:bg-amber-900/40 border-b-2 border-amber-400 dark:border-amber-600 text-amber-900 dark:text-amber-100">
            <div className="flex items-center gap-2 px-6 py-2 text-sm">
                <AlertTriangle className="h-4 w-4 flex-shrink-0" />
                {overrideEmail ? (
                    <span>
                        <strong>Test mode aktiv</strong> — alle emails sendes til{' '}
                        <code className="bg-amber-200 dark:bg-amber-950 px-1.5 py-0.5 rounded font-mono text-xs">
                            {overrideEmail}
                        </code>{' '}
                        i stedet for til kunden. Slå fra under Indstillinger.
                    </span>
                ) : (
                    <span>
                        <strong>Test mode aktiv uden modtager</strong> — emails blokeres indtil du angiver en test-email under Indstillinger.
                    </span>
                )}
            </div>
        </div>
    );
}
